import { styled, Radio as MuiRadio, RadioProps as MuiRadioProps } from '@mui/material';
import { InputHTMLAttributes } from 'react';
import { getDataIdGenerator } from '../shared/utils/dataId';

const RADIO_SIZE = 14;

const RadioIcon = styled('span')(() => ({
  border: 'solid 2px var(--divider-color)',
  borderRadius: '50%',
  padding: 0,
  width: RADIO_SIZE,
  height: RADIO_SIZE,
  background: 'transparent'
}));

const RadioCheckedIcon = styled(RadioIcon)({
  borderColor: 'var(--primary-color)',
  borderWidth: '5px',
  position: 'relative',
  '&:before': {
    content: '""',
    backgroundColor: 'transparent',
    borderRadius: '50%',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    position: 'absolute'
  }
});

export const Radio = styled((props: MuiRadioProps & { dataId?: string }) => {
  const { dataId, inputProps, ...otherProps } = props;
  const dataIdGenerator = getDataIdGenerator(dataId);
  return (
    <MuiRadio
      checkedIcon={<RadioCheckedIcon />}
      icon={<RadioIcon />}
      disableRipple
      {...otherProps}
      inputProps={
        {
          'data-id': dataIdGenerator('radio-input'),
          ...inputProps
        } as InputHTMLAttributes<HTMLInputElement>
      }
    />
  );
})(() => ({
  padding: 0,
  '&.MuiRadio-root': {
    position: 'relative',

    input: {
      zIndex: 2
    },

    '&:hover, &.Mui-focusVisible': {
      backgroundColor: 'transparent',
      '&:before': {
        content: '""',
        backgroundColor: 'var(--text-default-color)',
        opacity: 0.05,
        width: '35px',
        height: '35px',
        position: 'absolute',
        borderRadius: '50%'
      }
    }
  },
  '&.Mui-checked:hover, &.Mui-checked.Mui-focusVisible': {
    '&::before': {
      backgroundColor: 'var(--primary-color)'
    }
  },

  '&.Mui-disabled > span': {
    borderColor: 'var(--surface-bg-overlay-color)',
    borderWidth: '7px'
  },
  '&.Mui-disabled.Mui-checked > span': {
    borderWidth: '3.5px'
  },
  '&.Mui-disabled.Mui-checked > span:before': {
    backgroundColor: 'var(--text-secondary-color)'
  }
}));
